import TagManager from 'react-gtm-module';
import Config from "amn/Config";
import "./privado.css";

if (Config.GTM_ID) {
  TagManager.initialize({gtmId: Config.GTM_ID});
}

